'use client';

import React from 'react';
import { createStore, Provider } from 'jotai';

type JotaiProviderProps = {
  children: React.ReactNode;
  isDesign: boolean;
};

export function JotaiProvider({ children, isDesign }: JotaiProviderProps) {
  const store = React.useMemo(() => createStore(), []);
  if (!isDesign) {
    return <Provider store={store}>{children}</Provider>;
  }
  return <>{children}</>;
}
